<template>
  <div
    v-track="{
      triggerType: 'browse',
      currentUrl: $route.path,
      behavior: '浏览首页',
      businessCode: 2000,
      actionType: 'home-view',
    }"
  >
    <div class="tabChange">
      <ul>
        <li :class="queryType === 'production' ? 'tabCur' : 'lastnoborder'">
          <span>
            <a
              v-on:click="prev()"
              href="javascript:;"
              class="leftArrow"
              v-track="{
                triggerType: 'click',
                currentUrl: $route.path,
                behavior: '首页产量左侧时间切换按钮',
                businessCode: 2001,
                actionType: 'home-production-left-click',
              }"
            ></a
            ><a
              v-on:click="
                queryType = 'production';
                init();
                titleText = '产量';
              "
              href="javascript:;"
              class="text"
              v-track="{
                triggerType: 'click',
                currentUrl: $route.path,
                behavior: '首页产量切换按钮',
                businessCode: 2002,
                actionType: 'home-production-click',
              }"
              >{{ year }}年{{ month }}月产量一览</a
            ><a
              v-on:click="next()"
              href="javascript:;"
              class="rightArrow"
              v-track="{
                triggerType: 'click',
                currentUrl: $route.path,
                behavior: '首页产量右侧时间切换按钮',
                businessCode: 2003,
                actionType: 'home-production-right-click',
              }"
            ></a
          ></span>
        </li>
        <li :class="queryType === 'sales' ? 'tabCur' : 'lastnoborder'">
          <span
            ><a
              v-on:click="prev()"
              href="javascript:;"
              class="leftArrow"
              v-track="{
                triggerType: 'click',
                currentUrl: $route.path,
                behavior: '首页销量左侧时间切换按钮',
                businessCode: 2004,
                actionType: 'home-sales-left-click',
              }"
            ></a
            ><a
              v-on:click="
                queryType = 'sales';
                init();
                titleText = '销量';
              "
              href="javascript:;"
              class="text"
              v-track="{
                triggerType: 'click',
                currentUrl: $route.path,
                behavior: '首页销量切换按钮',
                businessCode: 2005,
                actionType: 'home-sales-click',
              }"
              >{{ year }}年{{ month }}月销量一览</a
            ><a
              v-on:click="next()"
              href="javascript:;"
              class="rightArrow"
              v-track="{
                triggerType: 'click',
                currentUrl: $route.path,
                behavior: '首页销量右侧时间切换按钮',
                businessCode: 2006,
                actionType: 'home-sales-right-click',
              }"
            ></a
          ></span>
        </li>
      </ul>
    </div>
    <!--tabChange-->

    <!-- <div class="carDate">
      <div class="carFrame">
        <div class="deDate">
          <span class="cartype">乘用车</span>
          <count-to
            class="carnumb"
            :start-val="countTo.startVal"
            :end-val="total.lv.volume"
            :duration="countTo.duration"
            v-show="is_loaded"
          ></count-to>
          <ul>
            <li style="left: -10px; top: -10px">
              <pie-single
                :proportion="total.lv.yoy"
                data-type="yoy"
                :width="115"
                :height="115"
                v-if="is_loaded"
              />
            </li>
            <li style="left: 20px; top: -10px">
              <pie-single
                :proportion="total.lv.mom"
                data-type="mom"
                :width="115"
                :height="115"
                v-if="is_loaded"
              />
            </li>
          </ul>
        </div>

        <div class="deDate">
          <span class="cartype">乘用车</span>
          <count-to
            class="carnumb"
            :start-val="countTo.startVal"
            :end-val="total.pv.volume"
            :duration="countTo.duration"
            v-show="is_loaded"
          ></count-to>
          <ul>
            <li style="left: -10px; top: -10px">
              <pie-single
                :proportion="total.pv.yoy"
                data-type="yoy"
                :width="115"
                :height="115"
                v-if="is_loaded"
              />
            </li>
            <li style="left: 20px; top: -10px">
              <pie-single
                :proportion="total.pv.mom"
                data-type="mom"
                :width="115"
                :height="115"
                v-if="is_loaded"
              />
            </li>
          </ul>
        </div>

        <div class="deDate">
          <span class="cartype">轻型商用车</span>
          <count-to
            class="carnumb"
            :start-val="countTo.startVal"
            :end-val="total.lcv.volume"
            :duration="countTo.duration"
            v-show="is_loaded"
          ></count-to>
          <ul>
            <li style="left: -10px; top: -10px">
              <pie-single
                :proportion="total.lcv.yoy"
                data-type="yoy"
                :width="115"
                :height="115"
                v-if="is_loaded"
              />
            </li>
            <li style="left: 20px; top: -10px">
              <pie-single
                :proportion="total.lcv.mom"
                data-type="mom"
                :width="115"
                :height="115"
                v-if="is_loaded"
              />
            </li>
          </ul>
        </div>
      </div>
    </div> -->

    <div class="market">
      <div class="title">乘用车月度{{ titleText }}趋势</div>
      <bar-line
        :volume_data="totalVolumes"
        :forecastTimeNode="$store.state.time_node"
        :width="960"
        :height="400"
        :is_loading="is_loading"
      />
    </div>
    <!--market-->

    <div v-if="queryType === 'production'" class="mapdate">
      <div class="title">乘用车{{ month }}月{{ titleText }}分布概况</div>
      <div class="mapBox">
        <china-map
          :projects="mapVolumes ? mapVolumes.volumes : null"
          :is_jump="true"
          styles="width: 480px;height:400px;float:left; position:absolute"
          :is_loading="is_loading"
          v-track="{
            triggerType: 'click',
            currentUrl: $route.path,
            behavior: '首页地图',
            businessCode: 2007,
            actionType: 'home-map-click',
          }"
        />
        <bar
          axis_name="全国TOP10（辆）"
          :series_name="titleText"
          :projects="mapVolumes ? mapVolumes.charts : null"
          :grid="[{ x: '15%', y: '15%', width: '60%', height: '75%' }]"
          styles="width:480px;height:400px;float:right;margin-left:480px;"
          :is_loading="is_loading"
        />
      </div>
    </div>

    <div class="mapdate">
      <div class="title" style="float: left; position: absolute">
        {{ month }}月{{ titleText }}动力形式占比图
      </div>
      <div class="title" style="margin-left: 480px">最近12个月各车型级别份额变化</div>
      <div class="mapBox">
        <div style="float: left; position: absolute">
          <pie
            :volume_data="propulsionVolumes"
            :width="480"
            :height="400"
            :is_loading="is_loading"
          />
        </div>
        <div style="float: right; margin-left: 480px">
          <bar-ratio
            :volume_data="ratio_data"
            :width="480"
            :height="400"
            :barWidth="20"
            :barCategoryGap="16"
            :is_loading="is_loading"
          />
        </div>
      </div>
    </div>

    <div class="datacharts">
      <div class="title">乘用车{{ month }}月{{ titleText }}派系榜</div>
      <div class="chartsTab">
        <table cellpadding="0" cellspacing="0" border="0" width="100%">
          <tbody>
            <tr>
              <th width="60">排序</th>
              <th width="92">派系</th>
              <th width="92">{{ titleText }}</th>
              <th width="186"></th>
              <th width="110">月环比</th>
              <th width="110">月同比</th>
              <th>月累计同比</th>
            </tr>
            <tr v-for="(item, index) in brandOriginVolumes" :key="index">
              <td width="60">{{ ++index }}</td>
              <td width="92">{{ item.dataRowName }}</td>
              <td width="92">{{ item.currentMonth | num_format }}</td>
              <td width="186">
                <div class="scrolls">
                  <span
                    :style="{
                      width:
                        (
                          (item.currentMonth / brandOriginVolumes[0].currentMonth) *
                          100
                        ).toFixed(1) + '%',
                    }"
                  ></span>
                </div>
              </td>
              <td
                width="110"
                :style="
                  item.currentMonth < item.lastMonth && item.lastMonth !== 0
                    ? 'color: red;'
                    : ''
                "
              >
                {{
                  item.lastMonth === 0
                    ? "-"
                    : (
                        ((item.currentMonth - item.lastMonth) / item.lastMonth) *
                        100
                      ).toFixed(1) + "%"
                }}
              </td>
              <td
                width="110"
                :style="
                  item.currentMonth < item.currentMonthOfLastYear &&
                  item.currentMonthOfLastYear !== 0
                    ? 'color: red;'
                    : ''
                "
              >
                {{
                  item.currentMonthOfLastYear === 0
                    ? "-"
                    : (
                        ((item.currentMonth - item.currentMonthOfLastYear) /
                          item.currentMonthOfLastYear) *
                        100
                      ).toFixed(1) + "%"
                }}
              </td>
              <td
                :style="
                  item.thisYear1toCurrentMonth < item.lastYear1toCurrentMonth &&
                  item.lastYear1toCurrentMonth !== 0
                    ? 'color: red;'
                    : ''
                "
              >
                {{
                  item.lastYear1toCurrentMonth === 0
                    ? "-"
                    : (
                        ((item.thisYear1toCurrentMonth - item.lastYear1toCurrentMonth) /
                          item.lastYear1toCurrentMonth) *
                        100
                      ).toFixed(1) + "%"
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="datacharts">
      <div class="title">乘用车{{ month }}月{{ titleText }}车企榜</div>
      <div class="chartsTab">
        <table cellpadding="0" cellspacing="0" border="0" width="100%">
          <tbody>
            <tr>
              <th width="60">排序</th>
              <th width="92">车企</th>
              <th width="92">{{ titleText }}</th>
              <th width="186"></th>
              <th width="110">月环比</th>
              <th width="110">月同比</th>
              <th>月累计同比</th>
            </tr>
            <tr v-for="(item, index) in manufacturerVolumes" :key="index">
              <td width="60">{{ ++index }}</td>
              <td width="92">{{ item.dataRowName }}</td>
              <td width="92">{{ item.currentMonth | num_format }}</td>
              <td width="186">
                <div class="scrolls">
                  <span
                    :style="{
                      width:
                        (
                          (item.currentMonth / manufacturerVolumes[0].currentMonth) *
                          100
                        ).toFixed(1) + '%',
                    }"
                  ></span>
                </div>
              </td>
              <td
                width="110"
                :style="
                  item.currentMonth < item.lastMonth && item.lastMonth !== 0
                    ? 'color: red;'
                    : ''
                "
              >
                {{
                  item.lastMonth === 0
                    ? "-"
                    : (
                        ((item.currentMonth - item.lastMonth) / item.lastMonth) *
                        100
                      ).toFixed(1) + "%"
                }}
              </td>
              <td
                width="110"
                :style="
                  item.currentMonth < item.currentMonthOfLastYear &&
                  item.currentMonthOfLastYear !== 0
                    ? 'color: red;'
                    : ''
                "
              >
                {{
                  item.currentMonthOfLastYear === 0
                    ? "-"
                    : (
                        ((item.currentMonth - item.currentMonthOfLastYear) /
                          item.currentMonthOfLastYear) *
                        100
                      ).toFixed(1) + "%"
                }}
              </td>
              <td
                :style="
                  item.thisYear1toCurrentMonth < item.lastYear1toCurrentMonth &&
                  item.lastYear1toCurrentMonth !== 0
                    ? 'color: red;'
                    : ''
                "
              >
                {{
                  item.lastYear1toCurrentMonth === 0
                    ? "-"
                    : (
                        ((item.thisYear1toCurrentMonth - item.lastYear1toCurrentMonth) /
                          item.lastYear1toCurrentMonth) *
                        100
                      ).toFixed(1) + "%"
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="datacharts">
      <div class="title">乘用车{{ month }}月{{ titleText }}车系榜</div>
      <div class="chartsTab">
        <table cellpadding="0" cellspacing="0" border="0" width="100%">
          <tbody>
            <tr>
              <th width="60">排序</th>
              <th width="92">车系</th>
              <th width="92">{{ titleText }}</th>
              <th width="186"></th>
              <th width="110">月环比</th>
              <th width="110">月同比</th>
              <th>月累计同比</th>
            </tr>
            <tr v-for="(item, index) in modelLineVolumes" :key="index">
              <td width="60">{{ ++index }}</td>
              <td width="92">{{ item.dataRowName }}</td>
              <td width="92">{{ item.currentMonth | num_format }}</td>
              <td width="186">
                <div class="scrolls">
                  <span
                    :style="{
                      width:
                        (
                          (item.currentMonth / modelLineVolumes[0].currentMonth) *
                          100
                        ).toFixed(1) + '%',
                    }"
                  ></span>
                </div>
              </td>
              <td
                width="110"
                :style="
                  item.currentMonth < item.lastMonth && item.lastMonth !== 0
                    ? 'color: red;'
                    : ''
                "
              >
                {{
                  item.lastMonth === 0
                    ? "-"
                    : (
                        ((item.currentMonth - item.lastMonth) / item.lastMonth) *
                        100
                      ).toFixed(1) + "%"
                }}
              </td>
              <td
                width="110"
                :style="
                  item.currentMonth < item.currentMonthOfLastYear &&
                  item.currentMonthOfLastYear !== 0
                    ? 'color: red;'
                    : ''
                "
              >
                {{
                  item.currentMonthOfLastYear === 0
                    ? "-"
                    : (
                        ((item.currentMonth - item.currentMonthOfLastYear) /
                          item.currentMonthOfLastYear) *
                        100
                      ).toFixed(1) + "%"
                }}
              </td>
              <td
                :style="
                  item.thisYear1toCurrentMonth < item.lastYear1toCurrentMonth &&
                  item.lastYear1toCurrentMonth !== 0
                    ? 'color: red;'
                    : ''
                "
              >
                {{
                  item.lastYear1toCurrentMonth === 0
                    ? "-"
                    : (
                        ((item.thisYear1toCurrentMonth - item.lastYear1toCurrentMonth) /
                          item.lastYear1toCurrentMonth) *
                        100
                      ).toFixed(1) + "%"
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <advert v-if="is_advert" />
  </div>
</template>

<script>
// import CountTo from "vue-count-to";
// import PieSingle from "@/components/echarts/pie-single-charts";
import Pie from "@/components/echarts/pie-charts";
import BarLine from "@/components/echarts/bar-line-charts";
import Bar from "@/components/echarts/bar-charts";
import BarRatio from "@/components/echarts/bar-ratio-charts";
import ChinaMap from "@/components/echarts/map-charts";
import Advert from "@/components/advert";

export default {
  name: "index",
  metaInfo: {
    title: "中国汽车产销量数据、产能数据、预测数据智能分析平台 - 盖亚系统",
    meta: [
      {
        name: "keywords",
        content: "汽车产销量数据,汽车产能数据",
      },
      {
        name: "description",
        content:
          "盖亚系统-中国汽车产销量数据、产能数据、预测数据智能分析平台。含：汽车产量销量排行榜，汽车产销量分布地图，汽车产销量预测数据等。",
      },
    ],
  },
  components: {
    // CountTo,
    // PieSingle,
    Pie,
    Bar,
    BarRatio,
    ChinaMap,
    BarLine,
    Advert,
  },
  data() {
    return {
      endVal1: 0,
      year: 2020,
      month: 12,
      queryType: "production",
      titleText: "产量",
      rankVolumes: {},
      typeVolumes: {},
      totalVolumes: {},
      modelLineVolumes: {},
      brandOriginVolumes: {},
      manufacturerVolumes: {},
      mapVolumes: {},
      propulsionVolumes: {},
      ratio_data: {},
      is_loading: true,
      is_loaded: false,
      is_advert: true,
      total: {
        lv: {
          volume: 0,
          yoy: 0,
          mom: 0,
        },
        pv: {
          volume: 0,
          yoy: 0,
          mom: 0,
        },
        lcv: {
          volume: 0,
          yoy: 0,
          mom: 0,
        },
      },
      rate: {
        lv: {
          volume: 0,
          yoy: 0,
          mom: 0,
        },
        pv: {
          volume: 0,
          yoy: 0,
          mom: 0,
        },
        lcv: {
          volume: 0,
          yoy: 0,
          mom: 0,
        },
      },
      countTo: {
        startVal: 0,
        duration: 800,
      },
    };
  },
  created() {
    this.year = this.$store.state.year;
    this.month = this.$store.state.month;
    this.init();
  },
  computed: {
    typeVolumesSum() {
      let volumes = this.typeVolumes;
      let sum = {};
      sum.volume = 0;
      sum.yoY = 0;
      sum.moM = 0;
      for (let i in volumes) {
        sum.volume += Number(volumes[i].volume);
        sum.yoY += Number(volumes[i].yoY.replace("%", ""));
        sum.moM += Number(volumes[i].moM.replace("%", ""));
      }
      sum.yoY = sum.yoY.toFixed(1) + "%";
      sum.moM = sum.moM.toFixed(1) + "%";
      return sum;
    },
  },
  methods: {
    init(type) {
      let _this = this;
      let _year = this.year;
      let _month = this.month;

      _this.is_loading = true;

      switch (type) {
        case "prev":
          if (_month === 1) {
            _year--;
            _month = 12;
          } else {
            _month--;
          }
          break;
        case "next":
          if (_month === 12) {
            _year++;
            _month = 1;
          } else {
            _month++;
          }
          break;
      }

      this.$http({
        url: "/home/init",
        method: "get",
        crossdomain: true,
        params: {
          year: _year,
          month: _month,
          queryType: _this.queryType,
        },
      })
        .then(function (res) {
          _this.rankVolumes = res.data.rankVolumes;
          _this.brandOriginVolumes = _this.rankVolumes.filter(
            (volume) => volume.dataType === "TOP_Brand_Origin"
          );
          _this.manufacturerVolumes = _this.rankVolumes.filter(
            (volume) => volume.dataType === "TOP_Manufacture"
          );
          _this.modelLineVolumes = _this.rankVolumes.filter(
            (volume) => volume.dataType === "TOP_Model_Line"
          );
          _this.typeVolumes = res.data.typeVolumes;
          _this.totalVolumes = res.data.totalVolumes;
          _this.mapVolumes = res.data.mapVolumes;
          _this.propulsionVolumes = res.data.propulsionVolumes;
          _this.ratio_data = res.data.sizeVolumes;
          _this.total = JSON.parse(JSON.stringify(_this.rate));
          _this.typeVolumes.forEach(function (element) {
            switch (element.type) {
              case "PV":
                _this.total.pv.volume = element.volume;
                _this.total.pv.yoy = parseFloat(element.yoY.replace("%", ""));
                _this.total.pv.mom = parseFloat(element.moM.replace("%", ""));
                break;
              case "LCV":
                _this.total.lcv.volume = element.volume;
                _this.total.lcv.yoy = parseFloat(element.yoY.replace("%", ""));
                _this.total.lcv.mom = parseFloat(element.moM.replace("%", ""));
                break;
              case "LV":
                _this.total.lv.volume = element.volume;
                _this.total.lv.yoy = parseFloat(element.yoY.replace("%", ""));
                _this.total.lv.mom = parseFloat(element.moM.replace("%", ""));
                break;
            }
          });
          _this.year = _year;
          _this.month = _month;
          _this.is_loading = false;
          _this.is_loaded = true;
          _this.is_advert = res.data.isSenior || res.data.isApply ? false : true;
        })
        .catch(function (error) {
          _this.is_loading = false;
          console.log(error);
        });
    },
    prev() {
      this.init("prev");
    },
    next() {
      this.init("next");
    },
  },
};
</script>
